import React from 'react';

const EditorIcon: React.FC<{ color?: string }> = ({ color = '#888D96' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_23540_7742)">
      <path
        d="M11.7988 18.3203H17.7988"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M17.9074 8.63559L9.36434 17.1786L5.70442 17.6458L6.18236 13.9966L14.7254 5.45361L17.9074 8.63559Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_23540_7742">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EditorIcon;
